// CONSTANTS are all caps.
const NS = "CareSliderItem";
const CLS = "careSliderItem";
const WG = "." + CLS + "-";

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/careSliderItem.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class CareSliderItem {

	constructor($el) {
		// $el is the widget node return by the loadCareSliderItem function
		this.$el = $el;
	}

	init() {
		this.setCareSliderItem();
	}

    isDesktopSize() {
	    return window.innerWidth >= 1200;
    }


	setCareSliderItem() {
	}

}
